export const RESTRICTIONS_CODES_MAPPER = {
  undergraduate: 'undergraduate-students-allowed',
  postgraduate: 'postgraduate-students-allowed',
  'professional-placement': 'professionals-allowed',
  domestic: 'domestic-students-allowed',
  international: 'international-students-allowed',
  males: 'males-allowed',
  females: 'females-allowed'
};
